<template>
  <div class="debug-card">
    <vs-row>
      <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="12">
        <span class="aisea-text-14-400-white">- debug -</span>
      </vs-col>
    </vs-row>
    <div v-for="(value, key) in debugObject" :key="key">
      <vs-row>
        <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="3">
          <span class="aisea-text-14-400-white">{{ key }}</span>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="9">
          <span class="aisea-text-14-400-white truncate">{{ value }}</span>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>
/**
 * isDebugがtrueのときに表示するデバッグ用のコンポーネント
 * @parent LiveMap
 * @parent O.MapViewGridItem
 * @props debugObject: Object 表示する内容
 */
export default {
  name: "M.DebugCard",
  props: {
    debugObject: {
      type: Object,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/aisea/variables";

.debug-card {
  position: absolute;
  bottom: 52px;
  left: 48px;
  z-index: 3;
  width: 220px;
  background-color: rgba(61, 70, 86, 0.45);
  border-radius: 3px;
  padding: 12px;
}
</style>
